import { Dialog, DialogContent, DialogTitle, Grid, Button, MenuItem } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { CambiarCategoriaReclamo, FetchCategoriasReclamos } from '../../../../actions/reclamos/reclamosActions';

export const CambioCategoria = (props) => {
    const { solicitud, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin } = props;
    const [value, setValue] = useState(solicitud?.categoriaReclamo);
    const { listaCategoriasReclamos } = useSelector((state) => state.reclamos);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FetchCategoriasReclamos());
    }, [dispatch]);

    const onSubmitHandler = () => {

        const data = {
            idReclamo: solicitud?.id,
            categoriaReclamo: value,
        }
        dispatch(CambiarCategoriaReclamo(data, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin))
        props.closeModalHandler();
    };

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="xs"
                open={props.open}
                onClose={props.closeModalHandler}
            >
                <DialogTitle>
                    <span style={{ float: "left" }}>
                        Cambio Estado
                    </span>
                </DialogTitle>
                <DialogContent>
                    <ValidatorForm onSubmit={onSubmitHandler}>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                style={{ display: "flex", justifyContent: "center", gap: "2em" }}
                            >
                                <SelectValidator
                                    fullWidth
                                    margin="normal"
                                    label="Categoría"
                                    name="categoriaReclamo"
                                    disabled={false}
                                    value={value}
                                    onChange={(e) => setValue(e.target.value)}
                                    InputLabelProps={{ style: { fontWeight: "bold" } }}
                                    validators={["required"]}
                                    errorMessages={["Este campo es obligatorio"]}
                                    style={{ color: "#000" }}
                                >
                                    {listaCategoriasReclamos.map((e) => (
                                        <MenuItem key={e.id} value={e.id}>
                                            {e.descripcion}
                                        </MenuItem>
                                    ))}
                                </SelectValidator>
                            </Grid>
                        </Grid>
                        <div
                            style={{
                                margin: '1rem 0',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={props.closeModalHandler}>
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                disabled={props.disabled}
                                color="primary"
                            >
                                Guardar
                            </Button>
                        </div>
                    </ValidatorForm>
                </DialogContent>
            </Dialog>
        </>
    )
}
